import apiClient from './apiClient';

// Call Schedule (S agent) — tenant-scoped calls API.
export const callAPI = {
  summary: async () => {
    const res = await apiClient.get('/calls/summary');
    return res.data;
  },
  list: async (window = 'all') => {
    const res = await apiClient.get('/calls', { params: { window } });
    return res.data;
  },
  create: async (payload) => {
    const res = await apiClient.post('/calls', payload);
    return res.data;
  },
  update: async (id, payload) => {
    const res = await apiClient.patch(`/calls/${id}`, payload);
    return res.data;
  },
  cancel: async (id) => {
    const res = await apiClient.delete(`/calls/${id}`);
    return res.data;
  },
  remove: async (id) => {
    const res = await apiClient.delete(`/calls/${id}/permanent`);
    return res.data;
  },
  ask: async (text, thread) => {
    const res = await apiClient.post('/calls/ask', { text, thread });
    return res.data;
  },
  attendeeSuggestions: async (eventId) => {
    const res = await apiClient.get('/calls/attendee-suggestions', { params: { eventId: eventId || '' } });
    return res.data;
  },
  linkSearch: async (q) => {
    const res = await apiClient.get('/calls/link-search', { params: { q: q || '' } });
    return res.data;
  },
  peopleSearch: async (q) => {
    const res = await apiClient.get('/calls/people-search', { params: { q: q || '' } });
    return res.data;
  },
  requestReschedule: async (id) => {
    const res = await apiClient.post(`/calls/${id}/request-reschedule`);
    return res.data;
  },
  markScheduleSeen: async () => {
    const res = await apiClient.post('/leads/call-requests/seen');
    return res.data;
  },
  pendingNotify: async () => {
    const res = await apiClient.get('/calls/pending-notify');
    return res.data;
  },
  sendInvites: async (id) => {
    const res = await apiClient.post(`/calls/${id}/send-invites`);
    return res.data;
  },
  dismissNotify: async (id) => {
    const res = await apiClient.post(`/calls/${id}/dismiss-notify`);
    return res.data;
  },
};

export default callAPI;
